import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/akash.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillFacebook,
  AiFillMail,
  AiFillYoutube
} from "react-icons/ai";
import { FaLinkedinIn, FaMedium } from "react-icons/fa";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body" style={{ textAlign: "justify" }}>
            I am a passionate <b>Data Enthusiast</b> with about <b>3.5 years of experience</b> in the fields of <b>data science, machine learning, and software development</b>. Currently, I am working at a <b>renowned company in Japan</b>. I hold a <b>Bachelor’s degree in Software Engineering</b> from <b>Noakhali Science and Technology University</b>, with the <b>2nd merit position</b>.
              <br />
              {/* <br />I am fluent in classics like
              <i>
                <b className="green"> Python, PHP, JavaScript and Java. </b>
              </i>
              <br /> */}
              <br />
              {/* My field of Interest's are building innovative & efficient solutions in the areas of &nbsp;
              <i>
                <b className="purple">Data Science, Web Application</b> and
                also in areas related to{" "}
                <b className="purple">
                  Federated Learning.
                </b>
              </i> */}
              {/* <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i> */}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              I'll love to <span className="purple">connect </span>with you
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Akash-Debnath"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons">
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/akash-chandra-debnath-513125215/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/akash.aksh.524/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto: akash2513@student.nstu.edu.bd"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://youtube.com/playlist?list=PLBragTtHHO7rA6EPRP8YbVQTVeQliucVB&si=Owrrrddx4wUTHMCO"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillYoutube />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://akash-chandra-debnath.medium.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaMedium />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
